import { useState, useRef, useEffect } from "react";
import ArrowDownMobile from "../../assets/svg/ArrowDownMobile";
import ArrowUpMobile from "../../assets/svg/ArrowUpMobile";
import CustomText from "../atomic/CustomText";
import utils from "../../services/utils";

interface Step {
  stepTitle: string;
  displayWhen?: any;
}

interface MobileStepsDropdownProps {
  steps: Step[];
  values: any;
  current: string;
  onSelect: (stepKey: string) => void;
}

const MobileStepsDropdown: React.FC<MobileStepsDropdownProps> = ({
  steps,
  values,
  current,
  onSelect,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // filter visible steps
  const filteredSteps = steps.filter((step) => {
    if (step.displayWhen) {
      return utils.displayHandler(step.displayWhen, values);
    }
    return true;
  });

  const currentStep =
    filteredSteps.find((s) => s.stepTitle === current) ||
    filteredSteps.find((s) => s.stepTitle === "Select Test") ||
    filteredSteps.find((s) => s.stepTitle && s.stepTitle.trim() !== "");

  return (
    <div className="w-full relative" ref={containerRef}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex justify-between items-center rounded bg-white text-left border border-gray-200"
      >
        <div className="flex items-center justify-between w-full py-3 px-2">
          <CustomText
            text={currentStep?.stepTitle || "Select Step"}
            fontSize="text-sm"
            fontWeight="font-medium"
            fontColor="#18B5B7"
          />
          {open ? (
            <ArrowUpMobile color="#97A0AF" />
          ) : (
            <ArrowDownMobile color="#97A0AF" />
          )}
        </div>
      </button>

      {/* Dropdown List */}
      {open && (
        <div className="absolute z-[999] pb-2 w-full border shadow-md bg-white rounded-lg overflow-auto">
          <ul>
            {filteredSteps
              .filter((s) => s.stepTitle && s.stepTitle.trim() !== "")
              .map((step) => (
                <li key={step.stepTitle}>
                  <button
                    onClick={() => {
                      onSelect(step.stepTitle);
                      setOpen(false);
                      document
                        .getElementById(step.stepTitle)
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className={`w-full text-left px-4 py-2 flex items-center justify-between hover:bg-gray-100
  ${
    (current ? current === step.stepTitle : step.stepTitle === "Select Test")
      ? "bg-gray-50"
      : ""
  }
`}
                  >
                    <CustomText
                      text={step.stepTitle}
                      fontSize="text-sm"
                      fontWeight="font-medium"
                      fontColor={
                        (
                          current
                            ? current === step.stepTitle
                            : step.stepTitle === "Select Test"
                        )
                          ? "#18B5B7"
                          : "#97A0AF"
                      }
                    />
                  </button>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobileStepsDropdown;
